module.exports = {"full":{"All-instruments":"すべての楽器","No-guitar":"ギターなし"},"details":{"Lesson-Details":"レッスンの詳細","Tablature":"ギター譜"}};